import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IAdditionalTaskItem } from '../../models/additionalTaskItem.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class AdditionalTaskItemApiService {
  abstract getList(): Observable<IAdditionalTaskItem[]>;
}
